import { render, staticRenderFns } from "./ForecastingByDistributor.html?vue&type=template&id=486eded6&scoped=true&"
import script from "./ForecastingByDistributor.component.js?vue&type=script&lang=js&"
export * from "./ForecastingByDistributor.component.js?vue&type=script&lang=js&"
import style0 from "./ForecastingByDistributor.scss?vue&type=style&index=0&id=486eded6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486eded6",
  null
  
)

export default component.exports